import React from 'react';
import { useTranslation } from 'react-i18next';

export const UserStatusUnknownScene: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="content-center">
      <div className="alert alert-info">{t('establishing-session')}</div>
    </div>
  );
};
